import type { SaasWorkspace } from '../../../../server/intelligence/saas/workspace.js';
const initial: SaasWorkspace = {
  "schemaVersion": 3,
  "step": "brief",
  "mode": "hybrid",
  "brief": "",
  "sourceContext": "",
  "brand": {
    "name": "",
    "accent": "#E60175",
    "background": "#111111",
    "foreground": "#FFFFFF",
    "font": "Inter",
    "guidelines": "",
    "palette": [],
    "logoSourceId": "",
    "tone": "",
    "sourceConfidence": 0
  },
  "director": {
    "stage": "intake",
    "creationMode": "auto",
    "objective": "",
    "audience": "",
    "productName": "",
    "url": "",
    "durationTarget": 0,
    "platformKnown": false,
    "language": "en",
    "cta": "",
    "script": "",
    "accuracyMode": "balanced",
    "creativeFreedom": "medium",
    "vagueStreak": 0,
    "takeoverOffered": false,
    "asked": [],
    "questions": [],
    "thesis": null,
    "log": []
  },
  "format": {
    "aspect": "",
    "platformId": "generic",
    "overlay": "off",
    "captions": "off",
    "adaptedFrom": ""
  },
  "product": {
    "name": "",
    "url": "",
    "tagline": "",
    "category": "",
    "vocabulary": [],
    "features": [],
    "surfaces": [],
    "workflows": [],
    "claims": [],
    "evidence": [],
    "tokens": {
      "colors": [],
      "fonts": []
    },
    "profileId": "",
    "capturedAt": ""
  },
  "motionDNA": {
    "direction": "brand-native",
    "character": "cinematic",
    "energy": 0.55,
    "pace": 0.45,
    "elegance": 0.75,
    "playfulness": 0.1,
    "spatialDepth": 0.8,
    "bounce": 0,
    "cameraActivity": 0.65,
    "informationDensity": 0.35,
    "holdBias": 0.55,
    "accentUsage": 0.6,
    "primaryEase": "standard",
    "transitionFamily": "blur",
    "entranceFamily": "rise",
    "annotationFamily": "glow",
    "cursorCharacter": "precise",
    "source": "default",
    "rationale": ""
  },
  "voice": {
    "direction": {
      "language": "en",
      "locale": "",
      "accentPreference": "",
      "delivery": "narrative",
      "warmth": 0.55,
      "authority": 0.6,
      "energy": 0.5,
      "intimacy": 0.4,
      "pace": 0.5,
      "dramaticRange": 0.35,
      "targetDuration": 0,
      "rationale": ""
    },
    "voiceId": "",
    "voiceName": "",
    "provider": "",
    "model": "",
    "spokenText": "",
    "providerText": "",
    "sourceId": "",
    "charactersUsed": 0,
    "alignment": {
      "source": "none",
      "words": [],
      "mismatch": 0
    },
    "shortlist": [],
    "attempts": []
  },
  "versions": {
    "entries": [],
    "head": ""
  },
  "hyperframes": {
    "enabled": true,
    "artDirection": null,
    "treatment": {
      "status": "draft",
      "approvedAt": "",
      "approvedHash": "",
      "notes": ""
    },
    "compositions": [],
    "report": null
  },
  "sources": [],
  "reconstructions": [],
  "voiceDraft": {
    "text": "",
    "voice": "",
    "provider": "local",
    "rate": -5
  },
  "audioTracks": [],
  "engineJobs": [],
  "selectedSourceId": "",
  "beats": [],
  "selectedBeatId": "",
  "messages": [],
  "pendingJobId": ""
};
export function createSaasWorkspace(brief = '', name = ''): SaasWorkspace { return {...structuredClone(initial), brief, brand: {...initial.brand, name}}; }
